import React, { useContext } from 'react';
import styles from './AdviceDeleteFile.styles';
import { AppContext } from 'App.context.js';

export default function AdviceDeleteFile() {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  let message = translate('hbxProducts.adviceDeleteFileText');

  return (
    <div>
      <div style={styles.desc}>{message}</div>
    </div>
  );
}
